import type { BiothreatSignal } from "../AlertCuration/AlertCurationContext"
import type { WastewaterAnomaly } from "../Wastewater/WastewaterAnomalies"

export const buildBiothreatSignalsContextMessage = (row: BiothreatSignal) => {
  return [
    row.title,
    "",
    "I am investigating a potential alert from a given signal. Use the following information as a starting point to help me investigate the potential alert.",
    "",
    "```",
    `ID: ${row.id}`,
    `Title: ${row.title}`,
    `URL: ${row.url}`,
    `Publish Time: ${row.publish_time}`,
    `Source Name: ${row.source_name} `,
    // This is coming back as empty, but was covered up by MOCK_SIGNALS in local dev, so keeping the code here for when real data has this field populated
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    `Pruned Themes: ${(row.pruned_themes ?? []).join(", ")}`,
    `Threat Category: ${row.threat_category ?? "N/A"}`,
    `Description: ${row.description ?? "N/A"}`,
    `Resolved Location: ${row.resolved_location}`,
    `NWSS Meta: ${row.nwss_meta ? JSON.stringify(row.nwss_meta) : "N/A"}`,
    "```",
  ].join("\n")
}

export const buildWastewaterAnomalyChatContextMessage = (
  anomaly: WastewaterAnomaly
) => {
  return [
    `${anomaly.title} for ${anomaly.date}`,
    "",
    "I am investigating a potential anomaly from a wastewater anomaly. Use the following information as a starting point to help me investigate the anomaly.",
    "",
    "```",
    `ID: ${anomaly.id}`,
    `Title: ${anomaly.title}`,
    `Date: ${anomaly.date}`,
    `Site: ${anomaly.site}`,
    `Pathogen: ${anomaly.pathogen}`,
    anomaly.geotags.length > 0
      ? `Geotags: ${anomaly.geotags.map(geotag => geotag.name).join(", ")}`
      : "",
    "```",
  ].join("\n")
}
